// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-edit[data-v-b2e99c00]:before,.edit-free-response[data-v-b2e99c00]:before{opacity:0!important}#edit-icon[data-v-b2e99c00]{font-size:20px;color:#6b7280}#close-icon[data-v-b2e99c00]{font-size:18px;font-weight:900;color:#6b7280}", ""]);
// Exports
module.exports = exports;
